import "./sprinkles.css.ts.vanilla.js";
import "./touchable.css.ts.vanilla.js";
var f = "mhti6u1 _1y2v1nf9n", y = "mhti6u4", _ = "mhti6u1 _1y2v1nf9n _1y2v1nf65 _1y2v1nf6j _1y2v1nf6x _1y2v1nf7b _1y2v1nf5k _1y2v1nf9g _1y2v1nf7p _1y2v1nf2n _1y2v1nf5c _1y2v1nf9p";
export { f as base, y as notTouchable, _ as touchable };
